// src/App.js
import React from "react";
import { Routes, Route } from "react-router-dom";

/* Layouts */
import PublicLayout from "./layouts/PublicLayout";
import UserLayout from "./layouts/UserLayout";
import AdminLayout from "./layouts/AdminLayout";

/* Public Pages */
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import About from "./pages/About";
import Features from "./pages/Features";
import Services from "./pages/Services";
import Blog from "./pages/Blog";
import BlogDetail from "./pages/BlogDetail";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import Refund from "./pages/Refund";
import ApiDocs from "./pages/ApiDocs";
import Contact from "./pages/Contact";

/* User Pages */
import Dashboard from "./pages/user/Dashboard";
import NewOrder from "./pages/user/NewOrder";
import OrderHistory from "./pages/user/OrderHistory";
import Wallet from "./pages/user/Wallet";
import WalletHistory from "./pages/user/WalletHistory";
import Tickets from "./pages/user/Tickets";
import TicketView from "./pages/user/TicketView";
import Settings from "./pages/user/Settings";
import UserServices from "./pages/user/Services";
import MassOrder from "./pages/user/MassOrder";
import ApiKeys from "./pages/user/ApiKeys";

/* Admin Pages */
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminUsers from "./pages/admin/AdminUsers";
import AdminOrders from "./pages/admin/AdminOrders";
import AdminServices from "./pages/admin/AdminServices";
import AdminInternalOrders from "./pages/admin/AdminInternalOrders";
import AdminTickets from "./pages/admin/AdminTickets";
import AdminMassOrders from "./pages/admin/AdminMassOrders";
import AdminProviders from "./pages/admin/AdminProviders";
import AdminWallet from "./pages/admin/AdminWallet";
import AdminSettings from "./pages/admin/AdminSettings";
import AdminAnalytics from "./pages/admin/AdminAnalytics";
import AdminRevenue from "./pages/admin/AdminRevenue";
import AdminContact from "./pages/admin/AdminContacts"
import AdminInternalOrdersList from "./pages/admin/AdminInternalOrdersList";

/* Guards */
import ProtectedRoute from "./components/ProtectedRoute";
import AdminRoute from "./components/AdminRoute";

export default function App() {
  return (
    <Routes>

      {/* ========= PUBLIC ========= */}
      <Route element={<PublicLayout />}>
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/about" element={<About />} />
        <Route path="/features" element={<Features />} />
        <Route path="/services" element={<Services />} />
        <Route path="/blogs" element={<Blog />} />
        <Route path="/blogs/:slug" element={<BlogDetail />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/refund" element={<Refund />} />
        <Route path="/api-docs" element={<ApiDocs />} />
        <Route path="/contact" element={<Contact />} />
      </Route>

      {/* ========= USER ========= */}
      <Route element={<ProtectedRoute />}>
        <Route element={<UserLayout />}>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/new-order" element={<NewOrder />} />
          <Route path="/orders" element={<OrderHistory />} />
          <Route path="/wallet" element={<Wallet />} />
          <Route path="/wallet/history" element={<WalletHistory />} />
          <Route path="/tickets" element={<Tickets />} />
          <Route path="/tickets/:id" element={<TicketView />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/user/services" element={<UserServices />} />
          <Route path="/mass-order" element={<MassOrder />} />
          <Route path="/api-keys" element={<ApiKeys />} />
        </Route>
      </Route>

      {/* ========= ADMIN ========= */}
      <Route element={<AdminRoute />}>
        <Route element={<AdminLayout />}>
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/users" element={<AdminUsers />} />
          <Route path="/admin/orders" element={<AdminOrders />} />
          <Route path="/admin/services" element={<AdminServices />} />
          <Route path="/admin/internal-orders" element={<AdminInternalOrders />} />
          <Route path="/admin/tickets" element={<AdminTickets />} />
          <Route path="/admin/mass-orders" element={<AdminMassOrders />} />
          <Route path="/admin/providers" element={<AdminProviders />} />
          <Route path="/admin/wallet" element={<AdminWallet />} />
          <Route path="/admin/settings" element={<AdminSettings />} />
          <Route path="/admin/analytics" element={<AdminAnalytics />} />
          <Route path="/admin/revenue" element={<AdminRevenue />} />
          <Route path="/admin/contact" element={<AdminContact />} />
          <Route path="/admin/internal-orders/status" element={<AdminInternalOrdersList />} />
         </Route>
      </Route>

    </Routes>
  );
}
